/**
 * Keep cart actions in the drawer, including clicks before it has upgraded.
 */
async function openCartDrawer() {
  if (document.readyState === 'loading') {
    await new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
  }
  await customElements.whenDefined('theme-drawer');
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (drawer && typeof drawer.open === 'function') drawer.open();
}

// App-generated /cart links should use the same drawer as the header.
document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
  const url = new URL(link.href, location.href);
  const cartUrl = new URL(Theme.routes.cart_url, location.href);
  if (url.origin !== cartUrl.origin || url.pathname.replace(/\/$/, '') !== cartUrl.pathname.replace(/\/$/, '')) return;
  if (url.search || url.hash || !document.querySelector('theme-drawer#cart-drawer')) return;
  event.preventDefault();
  event.stopPropagation();
  void openCartDrawer();
}, true);

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;
  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });
  actions.openCart.configure({ handler: openCartDrawer });
}

if (window.Shopify?.actions) {
  init();
} else if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
